<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition">
    <template v-slot:activator="{ on }">
      <v-tooltip v-on="on" top>
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" fab color="secondary" v-on="on" @click="dialog=true">
            <v-icon dark>mdi-note-plus-outline</v-icon>
          </v-btn>
        </template>
        <span>New Note</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>New Note</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="AddNote()">Save</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-title class="red--text pa-4" v-if="error">{{error}}</v-card-title>
      <v-form ref="Note" class="pa-3">
        <v-text-field v-model="newNote.Name" label="Title" outlined @keyup="titleCheck"></v-text-field>
        <v-textarea auto-grow outlined label="Note" v-model="newNote.Note"></v-textarea>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "@/fb";
import { store } from "@/fb";

export default {
  props: ["SessionNotes", "index"],
  data: () => ({
    newNote: {},
    dialog: false,
    error: null,
  }),
  methods: {
    AddNote() {
      if (this.SessionNotes === undefined) {
        this.SessionNotes = [];
      }
      if (
        this.SessionNotes.find(({ Name }) => Name === this.newNote.Name) ===
        undefined
      ) {
        this.dialog = false;
        this.SessionNotes.push(this.newNote);
        db.collection("campaigns")
          .doc(store.CurrentCampaign.id)
          .update({ SessionNotes: this.SessionNotes });
        this.newNote = {};
        this.error = null;
      } else {
        this.error = "That title alreay exist for another session note";
      }
    },
    titleCheck() {
      if (
        this.SessionNotes.find(({ Name }) => Name === this.newNote.Name) ===
        undefined
      ) {
        this.error = null;
      } else {
        this.error = "That title alreay exist for another session note";
      }
    },
  },
};
</script>
